import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import AddNewKla from './AddNewKla';
import { DeleteKla, EditKla, GetKlaListAdmin, GetKlaListForSearchFilter, hideKLA } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Select from "react-select";
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import ConstituencyMapping from './ConstituencyMapping';
import { toast, ToastContainer } from 'react-toastify';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const styleMM = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
    maxHeight: '90%',
    overflowY: 'hidden' // Make the Box scrollable
};

function TableKla() {
    const { addKLA, setaddKLA } = useContext(addcontext)
    const [klaList, setKlaList] = useState([])
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const [klaoptions, setKlaOptions] = useState([]);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [idToDelete, setidToDelete] = useState()
    const [errMsg, setErrMsg] = useState()
    const [errMsgEdt, setErrMsgEdt] = useState()
    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }
    const [tableDetails, setTableDetails] = useState()

    const [openSS, setOpenSS] = useState(false);
    const [isEditedSS, setIsEditedSS] = useState(1)
    const handleOpenSS = () => setOpenSS(true);
    const handleCloseSS = () => setOpenSS(false);

    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        // rows: {
        //     style: rowData => ({
        //         backgroundColor: rowData.is_active ? 'red' : 'blue', // Change row color based on the value of active
        //         minHeight: '50px',
        //     }),
        // },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },

    };
    //each object in the columns array represents a single column
    //The selector function occurs once for each row of data in the table
    const columns = [
        {
            //name of the column
            name: 'Sl No',
            // selector is a function that takes a row of data and returns the value to be displayed in the column for that row
            selector: row => row.slno,
            //boolean value indicates that the column can be sorted
            sortable: true,

        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,


        },

        {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
        {
            name: 'Constituency mapping',
            selector: row => row.constmapp,
            // Set a fixed width for the "Action" column
            minWidth: '170px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '180px',
            // sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.kla,
            sortable: true,


        },
        {
            name: 'Start Date',
            selector: row => row.startdate,
            sortable: true,
        },
        {
            name: 'End Date',
            selector: row => row.enddate,
            sortable: true,
        },
        {
            name: 'Total Sessions',
            selector: row => row.sessions,
            sortable: true,
        },
        {
            name: 'Total Sittings',
            selector: row => row.sittings,
            sortable: true,
        },
        {
            name: 'Business Hours',
            selector: row => row.business,
            sortable: true,
        },


        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },

        // {
        //     name: 'Visible',
        //     selector: row => row.visible,
        //     sortable: true,
        //     minWidth: '120px', // Adjust the width as needed
        //     maxWidth: '140px',
        // },
        {
            name: 'Delete',
            selector: row => row.active,
            // sortable: true,
        },
        // {
        //     name: 'Hide',
        //     selector: row => row.Hide,
        //     // sortable: true,
        // },
    ];

    useEffect(() => {
        getKlaList()
    }, [isEdited, addKLA])

    const getKlaList = async () => {
        const result = await GetKlaListAdmin()
        setKlaList(result?.data?.data)
        setErrMsg(result?.response?.data?.message)
        console.log(result);
    }

    const hideOrUnhide = async (klaID) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await hideKLA({ pk: klaID }, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteKla(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    var data = []
    //sets the value for each row assuming there are 50 rows
    klaList && klaList?.map((item, index) => {
        // const id = ; // Assuming ids start from 1
        const slno = index + 1
        const id = item.kla_id
        const kla = <mark className='rounded px-1' >KLA {item.kla_no}</mark>;
        const startdate = item.constitution_date;
        const enddate = item.dissolution_date;
        const sessions = item.total_no_of_sessions
        const sittings = item.total_sittings
        const business = item.total_business_hours
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)

        const constmapp = <button onClick={() => handleConstMapping(item)} className='ms-2 text-white p-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }}>Constituency mapping</button>

        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.kla_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const visible = <div className='flex flex-row justify-center items-center'>
            <Icon icon={`${item.is_visible ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item.is_visible ? 'green' : 'red'}` }} className='text-lg' />
            <button onClick={() => hideOrUnhide(item.kla_id)} className='ms-2 text-white px-2 py-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} >{item.is_visible ? 'Hide' : 'Unhide'}</button>
        </div>

        const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;

        //an object newObj is created with properties id, slno, kla, chiefminister, startdate, enddate, and Action.
        const newObj = { slno, id, kla, startdate, enddate, sessions, sittings, business, createdAt, updatedAt, active, visible, Action, constmapp };
        //appends newObj to end of data array
        data.push(newObj)
    })


    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()
        klaListCallApi();


    }

    const klaListCallApi = () => {
        try {
            // const result = await GetKlaListForSearchFilter();
            // console.log(result);
            // setKlaList(result?.data?.data)
            const options = klaList.map(item => ({
                value: item.kla_id,
                label: `KLA${item.kla_no}`,
                valueApi: item.kla_id
            }));

            setKlaOptions(options);


        } catch (error) {
            console.error("Error fetching Kla list for filter:", error);
        }
    }

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };

        dataToEdit.kla_no = dataToEdit?.kla_no?.value
        // console.log(dataToEdit);
        const result = await EditKla(dataToEdit, reqHeader)
        console.log(result);
        setErrMsgEdt(result?.response?.data?.message)
        if (result?.status == 200) {
            handleClose()
            setIsEdited(isEdited + 1)
            toast.success('KLA details edited successfully')
        }
        else {
            toast.error(result?.response?.data?.message ?? 'There was a problem editing kla')
        }
    }


    const handleConstMapping = (item) => {
        console.log(item);
        handleOpenSS()
        setTableDetails(item)
    }

    const handleEndDateClear = () => {
        setDataToEdit({ ...dataToEdit, dissolution_date: '' })
        setTimeout(() => {
            setDataToEdit({ ...dataToEdit, dissolution_date: null })

        }, 100)
    }

    return (
        <>
            {addKLA ?
                <AddNewKla />
                :
                <>
                    {klaList?.length > 0 ?

                        <DataTable
                            title={<div className='flex flex-row items-center'><span className='me-2'>KLA List</span> <PopOver dataToDisplay={'Add Edit KLA'} /></div>}
                            columns={columns}
                            data={data}
                            customStyles={customStyles}
                            pagination
                            dense
                            highlightOnHover
                            selectableRowsHighlight
                            paginationPerPage={15} // Initial page size
                            paginationRowsPerPageOptions={[15, 30, 45, 100, 200]} // Options for users to change page size
                        // selectableRows
                        // progressPending
                        // progressComponent={<h1>load</h1>}


                        />
                        :
                        <>
                            {!errMsg ? <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                <SyncLoader
                                    color="#3498db"
                                    loading={true}
                                    speedMultiplier={1}
                                />
                                <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

                            </div>
                                :
                                <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                    <p className="text-red-500 flex flex-row items-center"><span>{errMsg}</span></p>

                                </div>
                            }
                        </>
                    }
                </>
            }

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        {/* Additional fields */}
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla" className='text-gray-500'>KLA</label>
                            <input
                                id='kla'
                                readOnly
                                placeholder={dataToEdit?.kla_no}
                                options={klaoptions}
                                value={dataToEdit?.kla_no}
                                // onChange={option => setDataToEdit({ ...dataToEdit, kla_no: option })}
                                className='bg-white w-full h-10 rounded-lg border border-dashed border-gray-300 text-gray-500 px-2'

                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Start date</label>
                            <input
                                id='field3'
                                value={dataToEdit?.constitution_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, constitution_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            /> 
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field4">End date</label>
                            <div className='flex flex-row gap-1 items-center'>
                                <input
                                    id='field4'
                                    value={dataToEdit?.dissolution_date}
                                    onChange={(e) => setDataToEdit({ ...dataToEdit, dissolution_date: e.target.value })}
                                    type="date"
                                    className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                                />
                                <div><button onClick={handleEndDateClear} className='px-2 bg-success border border-red-500 border-dashed text-red-500 hover:bg-red-500 hover:text-white rounded-lg h-10 transform duration-500 ease-in-out'>Clear</button></div>
                            </div>
                        </div>
                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>


            <Modal
                open={openSS}
                onClose={handleCloseSS}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleMM}>
                    <ConstituencyMapping handleCloseModalSS={handleCloseSS} detailsTable={tableDetails} />
                </Box>
            </Modal>

            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}

export default TableKla